import { useState, useEffect } from 'react'
import { Box, Button as MuiButton, useTheme } from '@mui/material'
import { Tooltip, useNotification } from 'packages/eid-ui'
import {
    useCheckIfMasterPasswordExist,
    useCredentialHiddenAttributes,
} from 'hooks'
import { PasswordModal } from 'components/PasswordModal'
import { Spinner } from 'packages/eid-ui'
import { TextFormatter } from 'components'
import { useTranslation } from 'react-i18next'
import { Icon } from 'packages/eid-icons'

const LockedPasswordBox = ({
    targetUrl,
    targetProperty,
    isClickable,
    validationMessage,
    showIcon,
    isDetailed = false,
}) => {
    useEffect(() => {
        if (!isClickable && isRevealed) {
            setIsRevealed(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isClickable])

    const [enableApi, setEnableApi] = useState(false)
    const { data, isInitialLoading } = useCredentialHiddenAttributes(
        targetUrl,
        enableApi,
    )
    const { t } = useTranslation()
    const { showSuccessMessage, showInformationMessage } = useNotification()
    const [fetchedValue, setFetchedValue] = useState()
    const [isRevealed, setIsRevealed] = useState(false)
    const [openPopover, setOpenPopover] = useState(false)
    const [clickCopy, setClickCopy] = useState(false)
    const [clickReveal, setClickReveal] = useState(false)
    const [disableCopy, setDisableCopy] = useState(false)
    const { masterPasswordExists } = useCheckIfMasterPasswordExist()
    const [passwordModalOpen, setPasswordModalOpen] = useState('')
    const theme = useTheme()

    useEffect(() => {
        if (clickCopy && data) {
            let result = data[targetProperty]
            hidePopover()
            if (result) {
                navigator.clipboard.writeText(result)
                showSuccessMessage(t('CopiedToClipboard'))
            } else {
                showInformationMessage(t('FailedToCopy'))
                setDisableCopy(true)
            }
            setClickCopy(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clickCopy, data])

    useEffect(() => {
        if (clickReveal && data) {
            let result = data[targetProperty] || '-'
            if (result === '-') {
                setDisableCopy(true)
            }
            hidePopover()
            setTimeout(() => {
                setIsRevealed(!isRevealed)
            }, [100])
            setFetchedValue(result)
            setClickReveal(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clickReveal, data])

    const showPopover = () => {
        setOpenPopover(true)
    }

    const hidePopover = () => {
        setOpenPopover(false)
    }

    const handleCopy = () => {
        if (!masterPasswordExists()) {
            setPasswordModalOpen('enterPassword')
            return
        }
        setEnableApi(true)
        setClickCopy(true)
    }

    const toogleReveal = async () => {
        if (!isClickable) {
            return
        }
        if (isRevealed) {
            setIsRevealed(!isRevealed)
            return
        }
        if (!masterPasswordExists()) {
            setPasswordModalOpen('enterPassword')
            return
        }
        setEnableApi(true)
        setClickReveal(true)
    }

    if (isInitialLoading) {
        return (
            <Box display="flex">
                <Spinner />
            </Box>
        )
    }

    const passwordModal = (
        <PasswordModal
            showDefaultContent={false}
            open={passwordModalOpen}
            setOpen={setPasswordModalOpen}
        />
    )

    const HiddenPasswordText = (
        <TextFormatter
            sx={{
                fontSize: '13px',
                padding: isDetailed ? 'none' : '15px 6px',
                whiteSpace: 'nowrap',
            }}
            value={
                <>
                    {isRevealed
                        ? fetchedValue
                            ? fetchedValue
                            : '-'
                        : '*'.repeat(5)}
                    {showIcon && (
                        <Icon
                            name="View"
                            color="grey"
                            style={{ marginLeft: '4px', paddingTop: '2px' }}
                            onClick={toogleReveal}
                            width="10px"
                        />
                    )}
                </>
            }
        />
    )

    if (!isClickable) {
        return (
            <>
                {passwordModal}
                <Tooltip
                    PopperProps={{
                        disablePortal: true,
                        style: {
                            zIndex: 0,
                        },
                    }}
                    placement="top-start"
                    title={validationMessage}
                    arrow={false}
                    tooltipStyles={{ marginBottom: '-10px' }}
                >
                    <Box>{HiddenPasswordText}</Box>
                </Tooltip>
            </>
        )
    }
    return (
        <Box
            style={{ cursor: 'pointer' }}
            onMouseEnter={showPopover}
            onMouseLeave={hidePopover}
        >
            {passwordModal}
            <Box
                sx={{
                    background: theme?.palette?.tertiary?.main,
                    marginTop: isDetailed ? '-32px' : '-20px',
                    width: 'fit-content',
                    position: 'absolute',
                    zIndex: 999,
                    borderRadius: '5px',
                    marginLeft: '-40px',
                    '&:before': {
                        content: "''",
                        position: 'absolute',
                        left: '60px',
                        bottom: '-5px',
                        width: '10px',
                        height: '10px',
                        transform: 'rotate(45deg)',
                        backgroundColor: theme?.palette?.tertiary?.main,
                    },
                }}
                style={{
                    display: openPopover ? 'flex' : 'none',
                }}
                onMouseLeave={hidePopover}
            >
                <MuiButton
                    style={{
                        color: disableCopy ? 'gray' : 'white',
                        textTransform: 'none',
                    }}
                    size="small"
                    variant="text"
                    disabled={disableCopy}
                    onClick={handleCopy}
                >
                    {t('Copy')}
                </MuiButton>
                <MuiButton
                    style={{
                        color: 'white',
                        borderRadius: '0px',
                        borderLeft: '1px solid white',
                        textTransform: 'none',
                    }}
                    size="small"
                    variant="text"
                    onClick={toogleReveal}
                >
                    {isRevealed ? t('Hide') : t('Reveal')}
                </MuiButton>
            </Box>
            {HiddenPasswordText}
        </Box>
    )
}

export default LockedPasswordBox
